module.exports = __webpack_public_path__ + "static/media/24UHCHR9.ec7e545e.jpg";